import { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { ErrorResponse, privateApi } from 'api';
import { invalidateQueryKeys } from 'api/hooks/middlewares';

export interface ResendOnboardingParams {
  userId: string;
}

async function resendOnboarding({ userId }: ResendOnboardingParams): Promise<void> {
  await privateApi.post('/onboarding/resend', {
    userId,
  });
}

const useResendOnboarding = createMutation<void, ResendOnboardingParams, AxiosError<ErrorResponse>>({
  mutationFn: async (variables: ResendOnboardingParams) => resendOnboarding(variables),
  use: [invalidateQueryKeys([{ queryKey: ['student_profile'] }])],
});

export { resendOnboarding, useResendOnboarding };
